import { FC } from 'react';
import { useAppSelector } from '@/redux/hooks';
import { userSelectors } from '@/redux/selectors';
import { ToastContainer } from 'react-toastify';
import { COMMON_CONTAINER_ID, LIMITED_CONTAINER_ID } from '@/config';
import { AuthLayout } from '../AuthLayout';
import { BaseLayout } from '../BaseLayout';

interface LayoutProps {}

const Layout: FC<LayoutProps> = () => {
  const isAuth = useAppSelector(userSelectors.getAuth);

  return (
    <>
      {isAuth && <BaseLayout />}
      {!isAuth && <AuthLayout />}

      <ToastContainer
        containerId={COMMON_CONTAINER_ID}
        position="top-center"
        limit={3}
        enableMultiContainer
      />
      <ToastContainer
        containerId={LIMITED_CONTAINER_ID}
        position="top-center"
        theme="colored"
        limit={1}
        enableMultiContainer
      />
    </>
  );
};

export default Layout;
